import React from "react"

function Footer() {
  return (
    <div className="footer">
      <h6><a target="_blank" rel="noreferrer" href="https://sagarsaha.tech">TheSagarSaha</a> ©️ TwentyTwentyOne</h6>
    </div>
  )
}

export default Footer
